import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { COLORS } from '@helpers/constants'
import { HeadingType } from './style'

const Heading = (props) => {
    const { children, headingLevel, color = COLORS.BLACK.TEXT, size, ellipsis, extraClasses } = props

    const validHeadingLevels = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6']

    const safeHeading = headingLevel ? headingLevel.toLowerCase() : ''

    const HeadingElement = validHeadingLevels.includes(safeHeading)
        ? safeHeading
        : 'p'
    const ellipsisClasses = ellipsis
        ? 'overflow-ellipsis whitespace-nowrap overflow-hidden'
        : ''

    const className = classNames(HeadingType[headingLevel], color, size, ellipsisClasses, extraClasses)

    return <HeadingElement className={className}>{children}</HeadingElement>
}

Heading.propTypes = {
    children: PropTypes.any,
    headingLevel: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
    color: PropTypes.string,
    size: PropTypes.string,
    extraClasses: PropTypes.string,
}

export default Heading
